import React from 'react';
import { describeSelection, sectionLabel } from '../../utils/venueSections';

interface PitchGraphicProps {
  /** A pálya részeinek száma (Venue.sections, 1–4) */
  sectionCount: number;
  /** Kiemelt (foglalt) részek; null = teljes pálya foglalt */
  highlighted: number[] | null;
  /** Felirat a grafika alatt; alapértelmezetten a kijelölés leírása */
  label?: string;
  /** A részek nevei (Venue.sectionNames) - név híján "N. rész" */
  sectionNames?: string[] | null;
}

/**
 * Csak megjelenítő pályarajz: a foglalt részek kiemelve, a többi halvány.
 * A foglaltsági nézet slot-részleteihez, kattintás nélkül.
 */
const PitchGraphic: React.FC<PitchGraphicProps> = ({ sectionCount, highlighted, label, sectionNames }) => {
  if (sectionCount < 1) return null;

  const sections = Array.from({ length: sectionCount }, (_, i) => i + 1);
  const isHighlighted = (s: number) => highlighted === null || highlighted.includes(s);

  const gridClass =
    sectionCount === 3 ? 'grid-cols-3' : sectionCount === 1 ? 'grid-cols-1' : 'grid-cols-2';

  return (
    <div>
      <div className="relative overflow-hidden rounded-lg ring-1 ring-gray-300">
        {/* Pálya-dekoráció: középkör és felezővonal */}
        <div className="pointer-events-none absolute inset-0 z-10">
          <div className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white/50" />
          {sectionCount > 1 && (
            <div
              className={`absolute bg-white/50 ${
                sectionCount === 2 || sectionCount === 3
                  ? 'inset-y-0 left-1/2 w-0.5 -translate-x-1/2'
                  : 'left-0 right-0 top-1/2 h-0.5 -translate-y-1/2'
              }`}
            />
          )}
        </div>

        <div className={`grid ${gridClass} gap-0.5 bg-white`}>
          {sections.map((s) => (
            <div
              key={s}
              className={`flex h-14 items-center justify-center text-sm font-semibold sm:h-16 ${
                isHighlighted(s)
                  ? 'bg-green-600 text-white'
                  : 'bg-green-900/30 text-white/70'
              }`}
            >
              {sectionCount > 1 ? sectionLabel(s, sectionNames) : ''}
            </div>
          ))}
        </div>
      </div>
      <p className="mt-1.5 text-xs text-gray-600">
        {label ?? describeSelection(highlighted ?? sections, sectionCount, sectionNames)}
      </p>
    </div>
  );
};

export default PitchGraphic;
